import { createAction } from '@reduxjs/toolkit'

import { OrderDelivery } from '../lib/build-checkout-args'
import { Delivery } from '../types/delivery'
import { Payment, Payments } from '../types/payments'
import { PvzPointItem } from '../types/pvz'
import { Shop } from '../types/shop'

import { CustomerIndividual, CustomerLegal, DeliveryDetails } from './order-schema'

export { setGiftCardEvent, setGiftsEvent } from 'store/orderFlowActions'

export const customerIndividualDetailsSubmitedEvent = createAction<{
	details: CustomerIndividual
}>('order/customer-individual-details-submited')

export const customerLegalDetailsSubmitedEvent = createAction<{
	details: CustomerLegal
}>('order/customer-legal-details-submited')

export const companyTransferBonusSubmittedEvent = createAction<{
	value: `Y` | `N`
}>('order/company-transfer-bonus-submitted')

export const pickupPointDetailsSubmitedEvent = createAction<{
	shop: Shop
}>('order/pickup-point-details-submited')

export const pvzPointDetailsSubmitedEvent = createAction<{
	details: PvzPointItem
	deliveryPrice: number
}>('order/pvz-details-submited')

export const pvzDeliverySelectEvent = createAction<{
	deliveryId: string
	fiasId: string
}>('order/pvz-delivery-select')
export const updatePaymentMethods = createAction<{
	possiblePayments: Payments
}>('order/get_params')
export const filledDeliveryAddressEvent = createAction<{
	coords: [number, number]
	deliveryFrom?: string | number
	deliveryTo?: string | number
}>('order/filled-delivery-address')

export const deliveryDetailsSubmitedEvent = createAction<{
	details: DeliveryDetails
}>('order/delivery-details-submited')

export const selectDelivery = createAction<{
	delivery: Delivery
}>('order/set-selected-order')
export const selectDeliveryDate = createAction<{
	date: string
}>('order/set-selected-delivery-date')
export const clearDelivery = createAction('order/clear-delivery')
export const clearCourierDetails = createAction('order/clear-courier-details')

export const openPvz = createAction<{ fiasId: string }>('order/open-pvz')

export const cancelReceivingEdit = createAction('order/cancel-receiving-edit')
export const commitReceiving = createAction<{
	orderDelivery: OrderDelivery | null
}>('order/commit-receiving')

export const ignorePaymentFromUrl = createAction('order/ignore-payment-from-url')

export const paymentMethodSubmitedEvent = createAction<{
	option: Payment
	installmentCode: string | null
}>('order/payment-method-submited')

export const writeOffBonusesCountSubmitEvent = createAction<{
	count: number
}>('order/write-off-bonuses-count-submited')

export const errorEvent = createAction<{
	error: string
}>('order/error')

export const deliveryServiceDeclinedEvent = createAction('order/delivery-service-declined')
